/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dashboard_Driver_Active_Trip_OrdersInputs */

const vi_dashboard_driver_active_trip_orders = /** @type {(inputs: Dashboard_Driver_Active_Trip_OrdersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} đơn trong chuyến`)
};

/**

* @param {Dashboard_Driver_Active_Trip_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_active_trip_orders = /** @type {((inputs: Dashboard_Driver_Active_Trip_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_Active_Trip_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_active_trip_orders(inputs)
});